import { _receiveMessage } from "./postmessage.js";
(function () {
  _receiveMessage(function (event) {
    if (typeof event.a9customData === "undefined" || event.a9customData.a9message !== true) {
      // We message is not sent by our code
      return;
    }
    const iframe = document.getElementById("a9-iframe");
    if (iframe !== null) {
      iframe.style.height = event.a9customData.height;
      const scrollToTop = typeof event.a9customData.scrollToTop !== "undefined" ? event.a9customData.scrollToTop : true;
      if (scrollToTop) {
        window.scrollTo(0, 0);
      }
    }
  });
})();
